import { useEffect } from "react";

// Loads Google Analytics (GA4) and/or Meta Pixel only when their IDs are configured
// via env vars REACT_APP_GA_ID and REACT_APP_META_PIXEL_ID. No IDs = no tracking, no errors.
export default function Analytics() {
  useEffect(() => {
    const gaId = process.env.REACT_APP_GA_ID;
    const pixelId = process.env.REACT_APP_META_PIXEL_ID;

    if (gaId) {
      const s = document.createElement("script");
      s.async = true;
      s.src = `https://www.googletagmanager.com/gtag/js?id=${gaId}`;
      document.head.appendChild(s);
      window.dataLayer = window.dataLayer || [];
      function gtag() { window.dataLayer.push(arguments); }
      window.gtag = gtag;
      gtag("js", new Date());
      gtag("config", gaId);
    }

    if (pixelId) {
      /* eslint-disable */
      !(function (f, b, e, v, n, t, s) {
        if (f.fbq) return;
        n = f.fbq = function () {
          n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
        };
        if (!f._fbq) f._fbq = n;
        n.push = n; n.loaded = !0; n.version = "2.0"; n.queue = [];
        t = b.createElement(e); t.async = !0; t.src = v;
        s = b.getElementsByTagName(e)[0]; s.parentNode.insertBefore(t, s);
      })(window, document, "script", "https://connect.facebook.net/en_US/fbevents.js");
      window.fbq("init", pixelId);
      window.fbq("track", "PageView");
      /* eslint-enable */
    }
  }, []);

  return null;
}
